import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/apiStore';
import { clearError } from '../../store/errorSlice';
import { Transition } from '@headlessui/react';
import { XCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Button } from '../Button';

export const ErrorToast = () => {
  const dispatch = useDispatch();
  const { message, timestamp } = useSelector((state: RootState) => state.error);
  const isVisible = !!message;

  useEffect(() => {
    if (isVisible) {
      // Auto-dismiss after 5 seconds
      const timer = setTimeout(() => {
        dispatch(clearError());
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [timestamp, isVisible, dispatch]);

  const handleDismiss = () => {
    dispatch(clearError());
  };

  return (
    <div className="fixed top-4 right-4 z-50 flex items-start pointer-events-none">
      <Transition
        show={isVisible}
        enter="transform ease-out duration-300 transition"
        enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enterTo="translate-y-0 opacity-100 sm:translate-x-0"
        leave="transition ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="pointer-events-auto max-w-sm w-full bg-surface shadow-lg rounded-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div className="p-4">
            <div className="flex items-start">
              <div className="shrink-0">
                <XCircleIcon className="h-6 w-6 text-error" aria-hidden="true" />
              </div>
              <div className="ml-3 w-0 flex-1 pt-0.5">
                <p className="text-sm font-medium text-main">Error</p>
                <p className="mt-1 text-sm text-muted">{message}</p>
              </div>
              <div className="ml-4 shrink-0 flex">
                <Button variant="ghost" size="sm" onClick={handleDismiss} className="p-0">
                  <span className="sr-only">Close</span>
                  <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  );
};
